// Mock data for naari landing page clone (frontend-only)
import silkImg from "./assets/silk.jpg";
import banarasiImg from "./assets/banarasi.jpg";
import cottonImg from "./assets/cotton.jpg";
import everydayImg from "./assets/everyday.jpg";
import storyImg from "./assets/story.jpg";
import heroSecondaryImg from "./assets/hero-secondary.jpg";

export const WHATSAPP_LINK = "https://wa.me/919922345255";
export const INSTAGRAM_LINK = "https://www.instagram.com/naari_thesareesaga_/?hl=en";

export const announcement = "COMPLIMENTARY STYLING OVER WHATSAPP \u00B7 WE SHIP ACROSS INDIA";

export const nav = [
  { label: "Sarees", href: "#the-edit" },
  { label: "Our Story", href: "#our-story" },
  { label: "Notes from her", href: "#notes" },
  { label: "Find Us", href: "#find-us" },
];

export const hero = {
  eyebrow: "Everyday, made memorable",
  titleTop: "Wear the",
  titleItalic: "moment.",
  subtitle: "Sarees for the way you really live \u2014 soft mornings, last-minute plans, and every beautiful in-between.",
  badge: ["softly", "made"],
  tags: ["Handpicked textiles", "Made for repeat wears"],
  counter: "01 / 04 \u00B7 New Season",
  imageMain: "https://images.unsplash.com/photo-1749317776479-152916e4c158?auto=format&fit=crop&w=1000&q=80",
  imageSecondary: heroSecondaryImg,
};

export const marqueeWords = [
  "Quietly bold",
  "Made to be worn",
  "A little celebration",
  "Softly draped",
];

export const editIntro = {
  eyebrow: "01 / The Edit",
  titleTop: "Pieces for",
  titleItalic: "her pace.",
  description: "From sunlit cottons to evening silks, each naari saree is chosen for the life you will wear it into.",
};

export const filters = ["All", "Cotton", "Silk", "New Arrivals"];

export const products = [
  {
    id: 1,
    name: "Silk Sarees",
    detail: "Maroon \u00B7 hand-finished zari",
    tags: ["Silk", "New Arrivals"],
    justIn: true,
    image: silkImg,
    offset: false,
  },
  {
    id: 2,
    name: "Cotton Sarees",
    detail: "Earth stripe \u00B7 mulmul-soft handloom",
    tags: ["Cotton"],
    justIn: false,
    image: cottonImg,
    offset: true,
  },
  {
    id: 3,
    name: "Banarasi Sarees",
    detail: "Blush \u00B7 woven silver zari",
    tags: ["Silk", "New Arrivals"],
    justIn: true,
    image: banarasiImg,
    offset: false,
  },
  {
    id: 4,
    name: "Everyday Elegance Sarees",
    detail: "Ivory \u00B7 green temple border",
    tags: ["Cotton"],
    justIn: false,
    image: everydayImg,
    offset: false,
  },
];

export const story = {
  eyebrow: "02 / Our Story",
  titleTop: "A saree can",
  titleItalic: "hold a day.",
  paragraphs: [
    "naari began with a simple belief: the saree should meet you where you are. At the kitchen counter. On a first date. In the in-between hour before everyone arrives.",
    "We look for fabrics that breathe, colours that stay with you, and details that reveal themselves slowly. Thoughtful pieces, chosen to be worn often and remembered fondly.",
  ],
  link: "Read our full story",
  overlay: ["Not for the occasion.", "For the feeling."],
  image: storyImg,
};

export const features = [
  { no: "01", title: "Feel-good fabric", text: "Breathable cottons and fluid silks that move with your day." },
  { no: "02", title: "A considered edit", text: "Fewer, better pieces in colours you will return to." },
  { no: "03", title: "Here when you need us", text: "Personal styling, easy conversations, no hard sell." },
];

export const testimonialsIntro = {
  eyebrow: "03 / Notes from her",
  titleTop: "Worn.",
  titleItalic: "Then loved.",
};

export const testimonials = [
  {
    rating: "5.0",
    quote: "I wore my Everyday Elegance saree to work, a dinner, and my sister\u2019s haldi. Three very different days, one very loved saree. The drape is perfection.",
    name: "Rhea Kapoor",
    city: "Mumbai",
    initials: "RK",
  },
  {
    rating: "5.0",
    quote: "The cotton feels like a favourite old shirt but looks like I planned my whole outfit for hours. I reach for it more than anything else I own.",
    name: "Ananya Iyer",
    city: "Bengaluru",
    initials: "AI",
  },
  {
    rating: "5.0",
    quote: "Ordering felt like talking to a friend with very good taste. They helped me pick the burgundy Banarasi and it has become my signature.",
    name: "Meher Singh",
    city: "Delhi",
    initials: "MS",
  },
];

export const findUs = {
  eyebrow: "04 / Find Us",
  titleTop: "Come say hello,",
  titleItalic: "we would love that.",
  text: "Tell us where you are wearing it, what you usually reach for, or simply the colour you cannot stop thinking about. We are always a message away.",
  channels: [
    { type: "whatsapp", label: "WhatsApp us", value: "+91 99223 45255", href: WHATSAPP_LINK },
    { type: "insta", label: "Instagram", value: "@naari_thesareesaga_", href: INSTAGRAM_LINK },
    { type: "mail", label: "Write to us", value: "naari.celebratingher@gmail.com", href: "mailto:naari.celebratingher@gmail.com" },
    { type: "pin", label: "Ships from", value: "India, with love", href: null },
  ],
  newsletterTitle: "Stay in her loop.",
  newsletterText: "New edits, styling notes, and little reasons to dress up. Once in a while.",
  newsletterNote: "NO NOISE. JUST NAARI.",
};

export const footer = {
  tagline: ["For every version", "of her."],
  explore: [
    { label: "Sarees", href: "#the-edit" },
    { label: "Our Story", href: "#our-story" },
    { label: "Notes from her", href: "#notes" },
    { label: "Find Us", href: "#find-us" },
  ],
  contacts: [
    { type: "whatsapp", label: "WhatsApp us \u00B7 9922345255", href: WHATSAPP_LINK },
    { type: "mail", label: "naari.celebratingher@gmail.com", href: "mailto:naari.celebratingher@gmail.com" },
    { type: "pin", label: "India, with love", href: null },
    { type: "insta", label: "@naari_thesareesaga_", href: INSTAGRAM_LINK },
  ],
  copyright: "\u00A9 2026 NAARI OFFICIAL",
  note: "CELEBRATING HER, IN EVERY DRAPE.",
};
